module.exports = "\n<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"tabbed-question-context-view\">\n      <mat-tab-group\n        class=\"tab-group\"\n        disableRipple=true\n      >\n        <mat-tab class=\"mat-tab-labels\" [label]=\"item.label\" *ngFor=\" let item of tabQuestiondata\">\n          <span [innerHtml]=\"item.content | mpSafeHtml\"></span>\n        </mat-tab>\n      </mat-tab-group>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/tabbed-question-context-view/tabbed-question-context-view.html
// module id = Xusy
// module chunks = 3